/* global $, ShopgateProductDetailsCore */
import DebugConsole from '../debug/debug-console';
/* eslint-disable */
const debugConsole = new DebugConsole();
/**
 * Plugin creates and maintain step-by-step
 * mode for selecting item attributes (item
 * children).
 *
 * @depend shopgateUI (details-ui-plugins)
 * @param _productDetailsCore
 * @param params
 * @returns {*}
 */
var shopgateStepByStepSelectionUI = function (_productDetailsCore, params) {

  function _getInstance() {
    if (!this._instance) {
      this._instance = new stepByStepSelection(_productDetailsCore, params);
    }

    return this._instance;
  }

  return _getInstance.call(this);

  /**
   * Function body for singleton.
   * Singleton because sometimes core is initiated multiple times
   * and also this plugin is initiated multiple time.
   *
   * @param _productDetailsCore
   * @param params
   * @returns {*}
   */
  function stepByStepSelection(_productDetailsCore, params) {
    // local variables
    var _this                 = this,
        enabled               = true,
        $domElChoiceContainer = null,
        $uiSelects            = [], // gathers all selects injected to DOM for further checks and updates
        TIMEOUT_UPDATE_UI     = 100, // (ms) PRODUCT_STOCK_UPDATED is triggered by Core like a drunken bunny, there should be a timeout to avoid unnecessary updates
        updateUITimeoutId     = null, // for clearTimeout sake
        possibleEvents        = [],
        noSelection           = {
          PRODUCT_ID: 0,
          PARENT_ID: 0
        },
        parentProductId       = null;

    _this.templates = new stepByStepSelectionElements();

    /**
     * This object calls and listens to events.
     * All events are triggered on the object ("this" scope).
     * It is possible to listen to those events outside this
     * object.
     *
     * Events:
     *      PRODUCT_UPDATED       - every time core function sends products list
     *                            (eg. send the attributes for attributeID), this event
     *                            called
     *    PRODUCT_STOCK_UPDATED - triggered when livestock updated products list
     *    UI_CREATED            - triggered when UI (selects) is created and ready to work
     *    UI_BUSY               - triggered every time ui transitioning (eg. values atts changing)
     *    UI_IDLE               - triggered every time ui transitions are finished
     * @type {{PRODUCT_UPDATED: string, PRODUCT_STOCK_UPDATED: string, UI_CREATED: string, UI_BUSY: string, UI_IDLE: string}}
     */
    _this.events = {
      PRODUCT_UPDATED: 'sbs_product.updated',
      PRODUCT_STOCK_UPDATED: 'sbs_product.stock.updated',
      UI_CREATED: 'sbs_ui_created',
      UI_BUSY: 'sbs_ui_busy',
      UI_IDLE: 'sbs_ui_idle'
    };

    /** Callbacks for core class **/

    /**
     * Inits the plugin. Executed by products Core.
     *
     * @param callType
     * @param data
     * @returns {boolean}
     * @public
     */
    _this.onCoreInit = function (callType, data) {
      if (callType != 'products.ui') {
        return false;
      }
      // logs every event call on debug mode
      _throwEventsToConsole();
      // tells core that UI is not ready, important for history.replace() handling ( not ready state forbids to change the url)
      _productDetailsCore.setState(_productDetailsCore.getProductSelectionStates().STATE_STEPBYSTEP_UI_READY, false);
      // sets some variables for local scope
      _setVariables(data);
      // sets UI_IDLE and UI_BUSY listener for triggering the loading spinner
      _prepareSpinner();

      // if livestock is active, we should wait with ui creation until we have updated product
      if (_productDetailsCore.isComponentActive('livestock')) {
        $(_this).one(_this.events.PRODUCT_STOCK_UPDATED, function () {
          _createUI(data, { productsUpdated: true });
        });
      } else {
        _createUI(data);
      }
    };

    /**
     * Executed by core every time ui ask for attributes
     * values for given productId and attributeId.
     *
     * @param {string} callType products.data || products.ui
     * @param {Object} data Callback data
     * @returns {void}
     * @public
     */
    _this.onShowProductAttributeValuesList = function (callType, data) {
      if (!enabled) {
        return;
      }
      if (callType !== 'products.ui') {
        return;
      }
      _updateStepByStepLevelAttributes(data); // updates options with given data

      var states = _productDetailsCore.getStates();
      var stepByStepSelectionDone = states[
        _productDetailsCore.getProductSelectionStates().STATE_STEPBYSTEP_SELECTION_DONE
      ];

      if (stepByStepSelectionDone === false) {
        // sets the current selected product id to be the parent
        // so that on reload of an unfinished selection the parent will be shown again.
        _productDetailsCore.setProductId(parentProductId);

        // update sgData
        $(document).trigger('shopgateFramework.dataUpdate.product', {
          product: _productDetailsCore.getSelectedProduct(),
          product_price_info: _productDetailsCore.calculatePriceInfo(true),
        });

        // update Favourite List button
        $(document).trigger('shopgateFramework.updateFavouriteListIcon');
      }
    };

    /**
     * Opens first select with no user's decision.
     *
     * Selects are checks from first to last one if decision is made
     * (if value if not dummy product ID).
     *
     * When first select is found without decision it's focus is assign
     * to the select.
     *
     * If needed, every select without decision is marked with
     * .has-error
     *
     * @returns {boolean}
     */
    _this.focusOnNextDecision = function (options) {
      var focused  = false,
          defaults = {
            markUndecidedInvalid: true // if true, select will get has-error css class if nothing is selected
          };

      options = $.extend({}, defaults, options);

      $('select.step-by-step-select').each(function () {
        var $that     = $(this),
            $dropdown = $that.siblings('.bootstrap-select');

        if (parseInt($that.selectpicker('val')) === noSelection.PRODUCT_ID) {

          if (!focused) {
            setTimeout(function () {
              $.shopgate.scrollTo($dropdown.get(0), {
                callback: function () {
                  /**
                   * Check for visible 'cause tablet has clones for portait/landscape mode.
                   */
                  var $triggerTarget = $dropdown.find('.dropdown-toggle');
                  // should be faster to check dropdown since it has explicitly display:none assigned
                  if (!$dropdown.is(':visible')) {
                    $triggerTarget = $('.bootstrap-select.' + $that.data('attributeId') + ':visible .dropdown-toggle');
                  }

                  $triggerTarget.trigger('click');
                }
              });
            }, 0);
            focused = true;

            if (!options.markUndecidedInvalid) {
              return false;
            }
          }

          if (options.markUndecidedInvalid) {
            $dropdown.addClass('has-error');
          }

        } else {
          if (options.markUndecidedInvalid) {
            $dropdown.removeClass('has-error');
          }
        }
      });

      return focused;
    };

    /**
     * Executed by core when products list is updated by
     * live stock.
     *
     * @param callType
     * @param data
     */
    _this.onUpdateProductStockQuantity = function (callType, data) {
      if (!enabled) {
        return;
      }
      if (callType != 'products.ui') {
        return;
      }
      _trigger(_this.events.PRODUCT_STOCK_UPDATED);
    };

    /** *** **/

    /** Public methods */

    /**
     * Selects every step by step selection
     * with attributes of given product.
     *
     * Also, marks product as user selection.
     *
     * Can be called any time.
     *
     * @param product
     * @public
     */
    _this.forceStepByStepSelection = function (product) {
      if (!enabled) {
        return;
      }

      var debugMsg = 'Forcing step by step selection for product id: ' + product.product.id;
      _productDetailsCore.timedDebugGroupStart(debugMsg);

      _trigger(_this.events.UI_BUSY);
      _productDetailsCore.setState(_productDetailsCore.getProductSelectionStates().STATE_STEPBYSTEP_SELECTION_DONE, true, true);

      var selects = $('select.step-by-step-select');
      selects
        .prop('disabled', false)
        .each(function () {
          var currentSelect = $(this),
              attributeId   = currentSelect.data('attribute-id'),
              options       = currentSelect.find('option'),
              attrNumber    = parseInt(currentSelect.data('attribute-id-numeric'));

          /** first level options should not enabled **/
          if (attrNumber > 1) {
            options.prop('disabled', false);
          }

          $.each(options, function () {
            var option = $(this);
            // if there is an option with product id as a value, we simply select the option
            // two steps, 'cause we don't like string comparisons
            if (option.attr('value') == product.product.id) {
              currentSelect.val(product.product.id);
              return false;
            }
            // otherwise, we search for the same option name, change the value and then select it
            if (_sanitizeString(option.html()) == product.product[attributeId]) {
              option.attr('value', product.product.id);
              currentSelect.val(product.product.id);
              return false;
            }
          });

          // first attribute should not be updated.
          if (attrNumber > 1) {
            var attUpdateData = _productDetailsCore.getProductAttributeValuesForProductAttributeId(product.product.id, attrNumber, true);
            _updateStepByStepLevelAttributes(attUpdateData, { silent: true }); // silent mode, since we don't want to trigger any events this time
          }
        })
        .selectpicker('refresh');

      _changeSelectedProduct(product.product.id);
      _trigger(_this.events.UI_IDLE);

      _productDetailsCore.timedDebugGroupStop(debugMsg);

      return true;
    };

    /** privates */

    /**
     * Removes all created UI from DOM.
     *
     * @return (true when remove was done, false when there is nothing to remove)
     * @private
     */
    function _destroyUI() {
      $uiSelects = []; // resets DOM selects cache

      if ($domElChoiceContainer) {
        $domElChoiceContainer.remove();

        return true;
      }

      return false;
    }

    /**
     * Functions prepares and injects the UI to html DOM tree.
     *
     * Tricks for tablet version:
     * For tablet, there are more than one product-attributes containers.
     * This is why the code is prepared to use possible clones.
     *
     * @param data
     * @param opts
     * @returns {boolean}
     * @private
     */
    function _createUI(data, opts) {
      debugConsole.info('[SBS-CreateUI] Creating step by step choice');

      _destroyUI();
      _prepareHtml();

      var options                    = {
            productsUpdated: false // if ui creation is done before products are updated (by livestock for example), we need to postpone some transitions
          },
          attribute1WithSingleChoice = false;

      options = $.extend({}, options, opts);

      if (!(data.products.hasOwnProperty('children') && data.products.children)) {
        debugConsole.info('[SBS-CreateUI] Step by step choice aborted, no children given for the product.');
        enabled = false;
        _productDetailsCore.setState(_productDetailsCore.getProductSelectionStates().STATE_STEPBYSTEP_SELECTION_DONE, true, true);

        return false;
      }

      var productForSale      = _productIsForSale(data.products);
      var attributesByIdNames = _getAttributesGroupedByIdNames(data.products.children);
      var i = 0;
      for (var attributeName in attributesByIdNames) {
        var selectWrapper = _this.templates.getSelectWrapper(),
            $select       = _this.templates.getSelectElement(attributeName),
            disableOption = false;


        if (i !== 0 && productForSale) {
          $select.prop('disabled', true); // we disable every select but first if product is for sale
        }


        for (var key in attributesByIdNames[attributeName]) {
          if (!productForSale) {
            disableOption = true;
          } else {
            disableOption = false;
          }
          var optionVal  = attributesByIdNames[attributeName][key].productId,
              optionName = _sanitizeString(attributesByIdNames[attributeName][key].attributeValue),
              option     = _this.templates.getOptionElement({
                value: optionVal,
                name: optionName,
                subtext: data.products.parent.product[attributeName]
              });

          /**
           * For first attribute we should check if there is any available product for each.
           * If not, user should not be able to select this attribute, because it won't give
           * him any choice anyway.
           *
           * However, if entire product is not for sale, we simply disable all options.
           */
          if (productForSale && i == 0 && optionVal != noSelection.PRODUCT_ID) {
            if (!_productDetailsCore.isAttributeOrderable(i + 1, optionName)) {
              disableOption = true;
            }
          }

          if (disableOption === true) {
            option.prop('disabled', true);
          }

          $select.append(option);
        }
        $select
          .off('change')
          .on('change', _handleSelectionChanged);
        $uiSelects.push($select);
        selectWrapper.append($select);
        $domElChoiceContainer.append(selectWrapper); // there might be more than one $domElChoiceContainer, if so, append would clone selectWrapper
        $domElChoiceContainer.find('select.' + attributeName).selectpicker({
          showSubtext: true
        });
        //if it's first att and it contains only one value, let's select it
        if (productForSale && i == 0 && key == 0) {
          attribute1WithSingleChoice = $select; // we need this select for further use, it might be overwritten in t he next iteration
        }
        i++;
      }

      /**
       * Find the currently selected product which should be used for the inital set up
       */

      var currentProduct = _productDetailsCore.getSelectedProduct();

      // if we don't get a preselected product by the selected values we try to get a preselected
      // childproduct which is defined serversides when entering a child product directly
      if (!currentProduct) {
        currentProduct = {};
        currentProduct.product = _productDetailsCore.getPreselectedChildProduct();
      }

      if (currentProduct.product && currentProduct.product.id !== data.products.parent.product.id &&
        _productDetailsCore.productCanBeAddedToCart(currentProduct)
      ) {
        _productDetailsCore.setState(_productDetailsCore.getProductSelectionStates().STATE_STEPBYSTEP_SELECTION_DONE, true, true);

        if (options.productsUpdated) {
          _this.forceStepByStepSelection(currentProduct);
        } else {
          $(_this).one(_this.events.PRODUCT_UPDATED, function () {
            _this.forceStepByStepSelection(currentProduct);
          });
        }
        attribute1WithSingleChoice = false; // forceStepByStepSelection selects everything, no need to trigger the select event on first att even if it was flagged to do it before
      }

      $(document).on('shopgateFramework.ui.product.updated', function () {
        _trigger(_this.events.PRODUCT_UPDATED);
      });

      _productDetailsCore.setState(_productDetailsCore.getProductSelectionStates().STATE_STEPBYSTEP_UI_READY, true);

      /**
       * If first attribute has only one choice possible
       * there should be event called to simulate the user's
       * behaviour.
       *
       * It's not needed for following atts, because change
       * callback check for the next one if there is only
       * one choice possible and maintain this if needed.
       */
      if (attribute1WithSingleChoice) {
        if (options.productsUpdated) {
          attribute1WithSingleChoice.trigger('change');
        } else {
          $(_this).one(_this.events.PRODUCT_UPDATED, function () {
            attribute1WithSingleChoice.trigger('change');
          });
        }
      }

      var updateUIEventName = _this.events.PRODUCT_STOCK_UPDATED + '.sbs-updateUI';
      $(_this).off(updateUIEventName).on(updateUIEventName, function () {
        clearTimeout(updateUITimeoutId);
        updateUITimeoutId = setTimeout(
          function () {
            _updateUI();
          },
          TIMEOUT_UPDATE_UI
        );
      });

      _trigger(_this.events.UI_CREATED);
    }

    /**
     * Updates the first attribute options.
     * Change is only done if option needs to transist
     * between disabled/enabled state
     *
     * Triggered on PRODUCT_STOCK_UPDATED event.
     *
     * Fixes no-update on app when product data are first
     * fetched from SG server and then updated with livestock.
     *
     * @private
     */
    function _updateUI() {
      debugConsole.info('[SBS-UpdateUI] - updating UI');

      /**
       * Sometimes update stock happens even though parent product is deactivated
       * and no live stock is proceeded.
       *
       * If so, _updateUI should not be processed.
       */
      var products         = _productDetailsCore.getProducts(),
          productIsForSale = _productIsForSale(products);

      if (productIsForSale === false) {
        debugConsole.info('[SBS-UpdateUI] - aborting update UI - products is not for sale');

        return null;
      }

      var $select,
          $options,
          attributeId,
          $option,
          optionName,
          optionProductId,
          optionIsEnabled,
          optionIsOrderable,
          optionChanged = false;

      $.each($uiSelects, function () {
        $select = $(this);
        $options = $select.find('option');
        attributeId = $select.data('attribute-id-numeric');

        if (attributeId > 1) {
          return; // update should apply only for the first attribute, others depend on current user's selection and are updated with _handleSelectionChanged
        }
        $.each($options, function () {
          $option = $(this);
          // no need to do anything on dummy option
          if (parseInt($option.attr('value')) === noSelection.PRODUCT_ID) {
            return;
          }

          optionIsEnabled = !$option.prop('disabled');
          optionName = _sanitizeString($option.html());
          optionIsOrderable = _productDetailsCore.isAttributeOrderable(attributeId, optionName);

          if (optionIsOrderable !== optionIsEnabled) {
            $option.prop('disabled', !optionIsOrderable);
            optionChanged = true;
          }
          // if option is selected but also disabled, we change the current selection
          if (!optionIsOrderable && $option.prop('selected')) {
            debugConsole.info('[SBS-UpdateUI] Need to change user\'s selection for disabled option');
            $select
              .val(noSelection.PRODUCT_ID)
              .trigger('change');
          }
        });

        if (optionChanged) {
          debugConsole.info('[SBS-UpdateUI-YES] Need to refresh option valued ' + optionName + ' within attribute: ' + attributeId + '. Current optionIsOrderableValue is: ' + optionIsOrderable.toString());
          $('select.step-by-step-select.attribute_' + attributeId).selectpicker('refresh'); // select with possible clones

        } else {
          debugConsole.info('[SBS-UpdateUI-NO] No need to change option valued: ' + optionName + ' within attribute: ' + attributeId);
        }

      });
    }

    /**
     * Trims string and takes care of
     * entitity encoding (will return & instead
     * of &amp;
     *
     * @param string
     * @returns {*|jQuery}
     * @private
     */
    function _sanitizeString(string) {
      var cleanString = $('<div>').html($.trim(string)).text();

      return cleanString;
    }

    /**
     * Inits listener to UI_BUSY and UI_IDLE events
     * for spinner functionality.
     * @private
     */
    function _prepareSpinner() {
      var spinnerTimeoutHide = null,
          spinnerTimeoutShow = null;

      $(_this).on(_this.events.UI_BUSY, function () {
        clearTimeout(spinnerTimeoutShow);
        spinnerTimeoutShow = setTimeout(function () {
          $.shopgate.spinner('show');
        }, 100);
      });


      $(_this).on(_this.events.UI_IDLE, function () {
        clearTimeout(spinnerTimeoutShow);
        clearTimeout(spinnerTimeoutHide);
        spinnerTimeoutHide = setTimeout(function () {
          $.shopgate.spinner('hide');
        }, 100);
      });
    }

    /**
     * Checks if event is possible, and triggers the event.
     * @param event
     * @returns {boolean}
     * @private
     */
    function _trigger(event) {
      if (!possibleEvents.indexOf(event) === -1) {
        debugConsole.warn('[SBS] Not registered event for StepByStep choice triggered. Aborting. (' + event + ')');
        return false;
      }
      $(_this).trigger(event);

      return true;
    }

    /**
     * Updates options next to selected one depending on
     * selected product ID.
     *
     * Function starts with changed attributeId, however it might
     * also change following attributes for the user (for example
     * if in the next attribute there is no alternative).
     *
     *
     * @scope - "this" assumes jQuery on change event function scope ($(<select>).on('change');)
     * @private
     */
    function _handleSelectionChanged() {
      _trigger(_this.events.UI_BUSY);
      var chosenAttributesWithValues = {}, // user interface selection as object (<selects> to object equivalent)
          chosenProductId, // new product Id
          chosenAttributeId, // changed attribute Id
          changedAttribute           = parseInt($(this).data('attribute-id-numeric')),
          firstDummyAttributeId      = null;

      /**
       * Converts user interface selection to "chosen" object and
       * adjusts the user interface to meet new conditions.
       */
      $(this)
        .closest('.step-by-step-choice')
        .find('select')
        .each(function () {
          var attributeId             = parseInt($(this).data('attribute-id-numeric')),
              $thisWithClones         = $('select.step-by-step-select.attribute_' + attributeId),
              $selectpickerWithClones = $thisWithClones.siblings('.bootstrap-select');

          chosenAttributesWithValues[attributeId] = parseInt($(this).val());
          $thisWithClones.val(chosenAttributesWithValues[attributeId]);

          // handling changed attribute
          if (attributeId === changedAttribute) {
            chosenAttributeId = attributeId;
            if (chosenAttributesWithValues[attributeId] == noSelection.PRODUCT_ID) { // user changed selection to noSelection
              firstDummyAttributeId = attributeId;
              if (attributeId == 1) {
                chosenProductId = noSelection.PARENT_ID;
              } else {
                chosenProductId = chosenAttributesWithValues[attributeId - 1];
              }
            }
            else {
              chosenProductId = chosenAttributesWithValues[attributeId];
            }
            $thisWithClones.prop('disabled', false);
            $selectpickerWithClones.removeClass('has-error');
          } else if (attributeId > changedAttribute) {
            // handling following attributes transitions
            $thisWithClones.val(noSelection.PRODUCT_ID);
            if (!firstDummyAttributeId) {
              // Only mark this attribute as firstDummy if it actually has a dummy!
              if (chosenAttributesWithValues[attributeId] == noSelection.PRODUCT_ID) {
                firstDummyAttributeId = attributeId;
              }
              $thisWithClones.prop('disabled', false);
            } else {
              $thisWithClones.prop('disabled', true);
            }
          }

          $thisWithClones.selectpicker('refresh');
        });

      /**
       * If any of selections is call to choice selection is not done.
       * If there is nothing to choose left for attribures, selection is done.
       */
      if (firstDummyAttributeId) {
        _productDetailsCore.setState(_productDetailsCore.getProductSelectionStates().STATE_STEPBYSTEP_SELECTION_DONE, false, true);
      } else {
        _productDetailsCore.setState(_productDetailsCore.getProductSelectionStates().STATE_STEPBYSTEP_SELECTION_DONE, true, true);
      }

      /**
       * Obtaining if we need to update next select element.
       * By default, nextAtrributeId should be the changed one next one.
       */
      var nextAttributeId = null;
      if (firstDummyAttributeId) {
        // if there is any call to selection, we mark the selection to be updated
        nextAttributeId = firstDummyAttributeId;

      } else if (chosenAttributeId !== $.shopgate.objectLengthSafe(chosenAttributesWithValues)) {
        // if chosen one is not the last one
        nextAttributeId = chosenAttributeId + 1
      }
      /**
       * Exception for unexpected behaviour.
       * It should not happen, however there's a slight chance
       * that this script won't actually choose any
       * product Id (eg. data corrupted).
       */
      if (chosenProductId === noSelection.PRODUCT_ID) {
        _trigger(_this.events.UI_IDLE);
        return false;
      }

      if (nextAttributeId && nextAttributeId != 1) {
        $(_this).one(_this.events.PRODUCT_UPDATED, function () {
          _productDetailsCore.getProductAttributeValuesForProductAttributeId(chosenProductId, nextAttributeId);
        });

      } else {
        $(_this).one(_this.events.PRODUCT_UPDATED, function () {
          _trigger(_this.events.UI_IDLE);
        });
      }

      _changeSelectedProduct(chosenProductId, nextAttributeId);

    }

    /**
     * Marks productId as selected product.
     * Not related to real user choice.
     *
     * @param productId
     * @param attributeId (numeric)
     * @private
     */
    function _changeSelectedProduct(productId, attributeId) {
      if (typeof attributeId === 'undefined' || !attributeId) {
        attributeId = 1;
      }
      _productDetailsCore.updateSelectedProductAttributeValue(productId, attributeId, { // this only marks the selected product id to change
        forceUpdate: true
      });
      _productDetailsCore.hideVisibleProductAttributeValuesLists(productId, attributeId);
      _productDetailsCore.productAttributeValueListIsHidden(); // this actually changes the selected product Id
    }

    /**
     * Updates select's and options' states with
     * given related data (core.getProductAttributeValuesForProductAttributeId)
     *
     * @param data
     * @private
     */
    function _updateStepByStepLevelAttributes(data, opts) {
      var stdOpts = {
        silent: false // silent mode - no events would be triggered
      };
      var options = $.extend({}, stdOpts, opts);

      if (!data || !data.product_attribute.values.length) {
        if (!options.silent) {
          _trigger(_this.events.UI_IDLE);
        }
        return;
      }


      var newValues = data.product_attribute.values,
          toUpdate  = {};

      for (var newValueKey in newValues) {
        var newValue = newValues[newValueKey].product_attribute_value;
        if (newValue.selectable && newValue.orderable) {
          toUpdate[newValue.name] = newValue.product_id;
        }
      }
      var enabledOptionsNames = [],
          enabledOption,
          $select             = $('select.step-by-step-select.attribute_' + data.product_attribute.id) // might be clones included
            .prop('disabled', false)
            .find('option')
            .each(
              function () {
                var changedOption = _updateOptionEnableState($(this), toUpdate);
                if (changedOption.length && !changedOption.prop('disabled') && enabledOptionsNames.indexOf(changedOption.text()) === -1) {
                  enabledOption = changedOption;
                  enabledOptionsNames.push(enabledOption.text());
                }
              }
            )
            .end()
            .selectpicker('refresh');
      if (enabledOptionsNames.length === 1) {
        $select.val(enabledOption.attr('value'));
        if (!options.silent) {
          if ($select.length > 1) {
            $select.first().trigger('change');
          } else {
            $select.trigger('change');
          }
        }
      } else {
        if (!options.silent) {
          _trigger(_this.events.UI_IDLE);
        }
      }

    }

    /**
     * Decides if option should be disabled or not
     * for given attribute and changes the property
     * of option.
     *
     * Callback for $.each function.
     *
     * @param optionjQueryEl
     * @param productActiveAttrList
     * @returns jQueryEl
     * @private
     */
    function _updateOptionEnableState(optionjQueryEl, productActiveAttrList) {
      var $self     = optionjQueryEl,
          productId = parseInt($self.attr('value')),
          attrName  = _sanitizeString($self.html());

      if (productId == noSelection.PRODUCT_ID) {
        return $();
      }

      if (productActiveAttrList.hasOwnProperty(attrName)) {
        $self
          .attr('value', productActiveAttrList[attrName])
          .prop('disabled', false);
      } else {
        $self.prop('disabled', true);
      }
      return $self;
    }

    /**
     * Prepares the jQuery elements for step by step selection.
     *
     * @private
     */
    function _prepareHtml() {
      $domElChoiceContainer = _this.templates.getChoiceContainer({ parentId: noSelection.PARENT_ID });
      $('.product-attributes-wrapper').before($domElChoiceContainer);
      $domElChoiceContainer = $('.step-by-step-choice'); // @todo make this work on tablet better

    }

    /**
     * Checks if product if for sale.
     *
     * @param products
     * @returns {boolean}
     * @private
     */
    function _productIsForSale(products) {
      for (var childId in products.children) {
        var child = products.children[childId];
        if (_productDetailsCore.productCanBeAddedToCart(child)) {
          return true; // if any children can be added to cart, product is for sale
        }
      }

      return false;
    }

    /**
     * Creates a data structure of attributes grouped by identifier (attribute_XX)
     * @param {Object} children - List of child products
     * @returns {{}} e.g.:
     * {attribute_1: [
     *  {attributeValue: "Please Choose", productId: 0},
     *  {attributeValue: "Black", productId: 123},
     *  {attributeValue: "Pink", productId:124}
     * ]}
     * @private
     */
    function _getAttributesGroupedByIdNames(children) {
      var attributesByIdNames = _productDetailsCore.getAllAttributesGroupedByAttributeId(children);

      // add the "please choose" option to the attributes
      for (var attributeName in attributesByIdNames) {
        if (attributesByIdNames[attributeName].length > 1) {
          attributesByIdNames[attributeName].unshift({
            attributeValue: $.i18n._('common_please_choose'),
            productId: noSelection.PRODUCT_ID
          });
        }
      }

      return attributesByIdNames;
    }


    /**
     * sets variables
     *
     * @private
     */
    function _setVariables(data) {
      $.sgHelpers = $.sgHelpers || {};
      $.shopgate = $.shopgate || {};
      noSelection.PARENT_ID = parseInt(data.products.parent.product.id);
      for (var eventName in _this.events) {
        possibleEvents.push(_this.events[eventName]);
      }
      parentProductId = _productDetailsCore.getParentProductId();

      return true;
    }

    function _throwEventsToConsole() {
      $.each(_this.events, function (name, key) {
        $(_this).on(key, function () {
          debugConsole.info('[SBS] Step-by-step event triggered: ' + name);
        });
      })

    }


    // plugin constructor
    function _init() {
      // main plugin properties
      _this.vendor = 'Shopgate';
      _this.name = 'ShopgateStepByStepSelection';
      _this.type = ['products.ui'];

      return _this;
    }

    return _init();
  }

};

shopgateStepByStepSelectionUI.prototype._instance = null;

var stepByStepSelectionElements = function () {

  var templates = function () {
    var $elements = {
      selectWrapper: $('<div class="row product-frame">'),
      selectElement: $('<select class="form-control step-by-step-select">'),
      optionElement: $('<option class="no-sg-action">'),
      choiceContainer: $('<div class="step-by-step-choice">')
    };


    /**
     * Gets wrapper which keeps step by step
     * <select> element (singular!)
     *
     * @returns {*|jQuery}
     */
    this.cloneElement = function (name) {

      return $elements[name].clone();
    };

    this.getSelectWrapper = function () {
      return this.cloneElement('selectWrapper');
    };


    this.getSelectElement = function (attributeId) {
      var attributeIdNumeric = parseInt(attributeId.split('_')[1]),
          $element           = this
            .cloneElement('selectElement')
            .addClass(attributeId)
            .data('attribute-id', attributeId)
            .data('attribute-id-numeric', attributeIdNumeric);
      return $element;
    };

    this.getOptionElement = function (opts) {
      var options = {
        value: '',
        name: '',
        subtext: null
      };

      options = $.extend({}, options, opts);

      var $element = this
        .cloneElement('optionElement')
        .attr('data-subtext', options.subtext + ':') // .data doesn't work with selectpicker :(
        .attr('value', options.value)
        .html(options.name);

      return $element;
    };

    this.getChoiceContainer = function (opts) {
      var options = {
        parentId: 0
      };
      options = $.extend({}, options, opts);

      var $element = this
        .cloneElement('choiceContainer')
        .attr('id', 'step-by-step-choice-' + options.parentId);

      return $element;
    }
  };

  function _getInstance() {
    if (!this._instance) {
      this._instance = new templates();
    }

    return this._instance;
  }

  return _getInstance.call(this);
};

stepByStepSelectionElements.prototype._instance = null;


if (typeof ShopgateProductDetailsCore == 'object' && typeof ShopgateProductDetailsCore.registerPlugin == 'function') {
  if (ShopgateProductDetailsCore.isComponentActive('step_by_step_selection')) {
    ShopgateProductDetailsCore.registerPlugin(shopgateStepByStepSelectionUI);
  }
} else {
  console.error('No instance of "ShopgateProductDetailsCore" found');
}
/* eslint-enable */

// export
export default shopgateStepByStepSelectionUI;




// WEBPACK FOOTER //
// ./Library/1.0/common/product_details/jquery.shopgate-product-stepbystep-ui-plugins.js